import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showExternalPopup: false,
  showHomePopup: false,
  externalLink: "",
};

export const popupSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setShowExternalPopup: (state, action) => {
      state.showExternalPopup = action.payload;
    },
    setShowHomePopup: (state, action) => {
      state.showHomePopup = action.payload;
    },
    setExternalLink: (state, action) => {
      state.externalLink = action.payload;
    },
  },
});

export const { setShowExternalPopup, setExternalLink, setShowHomePopup } =
  popupSlice.actions;
export default popupSlice.reducer;
